import { onMounted, onBeforeUnmount } from 'vue'

import router from '@/router'
import { menuRouteEnum, menuRoutes } from '@/lib/menu-routes'
import { serviceTypeEnum } from '@/stores/portal.store'
import { useWebSiteStore } from '@/stores/web-site.store'

import { useDetectDevice } from './device'

const popStateStack = []

export const useNavigator = (onPopStateCallback) => {
  const { isMobile } = useDetectDevice()
  if (!isMobile) return

  const popStateHandler = () => {
    const last = popStateStack[popStateStack.length - 1]
    if (last) last()
  }

  onMounted(() => {
    if (popStateStack.length === 0) {
      window.addEventListener('popstate', popStateHandler)
    }
    popStateStack.push(onPopStateCallback)
    window.history.pushState(history.state, '', window.location.href)
  })

  onBeforeUnmount(() => {
    const idx = popStateStack.lastIndexOf(onPopStateCallback)
    if (idx !== -1) popStateStack.splice(idx, 1)
    if (popStateStack.length === 0) {
      window.removeEventListener('popstate', popStateHandler)
    }
  })
}

export const navigateToProject = (projectId, menuRoute = menuRouteEnum.PROJECTS) => {
  useWebSiteStore().editedProjectId = projectId
  return router.push(menuRoutes[menuRoute])
}

export const navigateToBudgetDocument = ({ year_mnemonic, number_mnemonic }) => router.push({
  path: menuRoutes[menuRouteEnum.ACCOUNTING_BUDGET_DOCUMENTS],
  query: { year_mnemonic, number_mnemonic },
})

export const navigateToWarehouseMovements = ({ warehouse = null, service = null }) => router.push({
  path: menuRoutes[menuRouteEnum.WAREHOUSE_LIST],
  query: Object.fromEntries(Object.entries({ warehouse, service }).filter(([, id]) => id)),
})

export const navigateToInvoice = (invoiceNumber) => router.push({
  path: menuRoutes[menuRouteEnum.ACCOUNTING_INVOICES],
  query: { invoice_number: invoiceNumber },
})

export const navigateToExpenseClaim = (expenseClaimId) => router.push({
  path: menuRoutes[menuRouteEnum.ACCOUNTING_EXPENSE_CLAIMS],
  query: { expense_claim: expenseClaimId },
})

export const navigateToCompany = ({ code }) => router.push({
  path: menuRoutes[menuRouteEnum.COMPANIES],
  query: { code },
})

export const serviceMenuRoute = (serviceType) => {
  if (serviceType === serviceTypeEnum.GROUP) return menuRouteEnum.GROUPS
  if (serviceType === serviceTypeEnum.STAFF) return menuRouteEnum.STAFFS
  return menuRouteEnum.EQUIPMENTS
}

export const navigateToService = ({ type, code }) => router.push({
  path: menuRoutes[serviceMenuRoute(type)],
  query: { code },
})

export const listingItemRoute = (listingId, itemCode) => ({
  path: menuRoutes[menuRouteEnum.LISTINGS],
  query: itemCode ? { listingId, itemCode } : { listingId },
})

export const navigateToListingItem = (listingId, itemCode) => router.push(listingItemRoute(listingId, itemCode))
